<script>
export default {
  props: {
    background: {
      default: null,
      type: String,
    },
    height: {
      default: 'auto',
      type: String,
    },
    gradient: {
      default: null,
      type: String,
    },
  },
  computed: {
    /**
     * We should compute the gradient color if user requesting a gradient
     */
    gradientColor() {
      return {
        '--heroGradientColor': this.gradient,
        '--heroGradientColorReduceOpacity': this.convertHex(this.gradient),
      }
    },
    heroHeight() {
      return {
        '--heroHeight': this.height,
      }
    },
  },
  methods: {
    /**
     * @ISSUE :
     * The gradient we've set not beauty as we imagine
     * So i create a method that we can use to reduce color
     * from the given color, then we add this to gradient color
     * to reduce its opacity
     * @param color
     * @return rgba
     */
    convertHex: function(color) {
      color = color.replace('#', '')
      var r = parseInt(color.substring(0, 2), 16)
      var g = parseInt(color.substring(2, 4), 16)
      var b = parseInt(color.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + '.75' + ')'
      return result
    },
  },
}
</script>

<template>
  <div class="w-100">
    <div
      v-lazy:background-image="background"
      class="jumbotron d-flex"
      :class="[
        $style.hasBackground,
        gradient !== null ? $style.hasGradient : '',
      ]"
      :style="[
        height !== null ? heroHeight : '',
        gradient !== null ? gradientColor : '',
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.hasBackground {
  height: var(--heroHeight);
  // padding: 8rem 0;
  background-repeat: no-repeat;
  background-position: calc(50% - -25%) 50%;
  background-size: cover;
  border-radius: 0;
  &.hasGradient {
    position: relative;
    h1 {
      font-weight: $semi-bold;
      color: #fff;
      opacity: 0.95;
    }
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: inherit;
      width: 100%;
      height: 100%;
      content: '';
      background: linear-gradient(
        to right,
        var(--heroGradientColor),
        var(--heroGradientColor),
        var(--heroGradientColorReduceOpacity),
        rgba(0, 0, 0, 0)
      );
    }
  }
}

@media only screen and (max-width: $mobile-sm) {
  .hasBackground {
    height: calc(var(--heroHeight) + 2rem);
    padding: 1rem 0;
    &.hasGradient {
      position: relative;
      h1 {
        font-size: 1.5rem;
      }
      [class='container'] {
        display: flex;
        align-items: center;
        height: 100%;
        text-align: center;
      }
      &::before {
        width: 75%;
      }
    }
  }
}
</style>
